import api from "@client/content/lib/api";
import { type ModuleApiInfo } from "@client/content/selectors";
import { type HttpApiResponse } from "@client/types/Api";
import { type Kpi } from "./types";

export default {
  getAggregate: (
    apiInfo: ModuleApiInfo,
    args: Kpi.Api.GetAggregateRequest
  ): Promise<HttpApiResponse<Kpi.Api.GetAggregateResponse>> =>
    api.get(apiInfo, `/api/site/v1/modules/kpi/aggregate`, args)
};
